import React, { useEffect, useLayoutEffect, useRef } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

export function Layout(): React.ReactElement {
  const location = useLocation();
  const navigate = useNavigate();
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0;
    }
    window.scrollTo(0, 0);
  }, [location.pathname, location.search]);

  useEffect(() => {
    const isRoot = location.pathname === "/";
    const webApp = window.Telegram?.WebApp;

    if (webApp?.BackButton) {
      if (isRoot) {
        webApp.BackButton.hide();
      } else {
        webApp.BackButton.show();
        const handleBack = () => navigate(-1);
        webApp.BackButton.onClick(handleBack);
        return () => {
          webApp.BackButton.offClick(handleBack);
        };
      }
    }
  }, [location.pathname, navigate]);

  return (
    <div
      style={{
        minHeight: "100vh",
        height: "100dvh",
        backgroundColor: "var(--color-canvas)",
        color: "var(--color-graphite)",
        display: "flex",
        justifyContent: "center",
        padding: "0",
        margin: "0",
      }}
    >
      <div
        ref={scrollContainerRef}
        data-testid="layout-scroll-container"
        style={{
          width: "100%",
          maxWidth: "480px",
          height: "100%",
          minHeight: "100%",
          padding: "16px 16px 26px 16px",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          overflowY: "auto",
        }}
      >
        <Outlet />
      </div>
    </div>
  );
}
